import styled from '@emotion/styled';
import React from 'react';
import { Text1 } from '../../components/typography/Text1';
import { Text2 } from '../../components/typography/Text2';
import { Text3 } from '../../components/typography/Text3';
import { Text4 } from '../../components/typography/Text4';
import { Text5 } from '../../components/typography/Text5';
import HorizontalFlex from '../../components/flex_layouts/HorizontalFlex';
import { useAppContext } from '../../context/AppContext';

const HeroSection = ({ ...props }) => {
  const { lastTableUpdateTime, setApplyPagination } = useAppContext();

  const onActionItemClick = () => {
    setApplyPagination(false);
    setTimeout(() => {
      window.print();
      setApplyPagination(true);
    }, 300);
  };

  const actions = [
    {
      imageSrc: '/image-1.png',
      text: 'Download PDF',
      onClick: onActionItemClick,
    },
    {
      imageSrc: '/image-2.png',
      text: 'Print',
      onClick: onActionItemClick,
    },
  ];

  return (
    <LayoutRoot {...props}>
      <MainContainer>
        <LeftContainer>
          <TitleContainer>
            <Text1>Available treatment options - NSCLC</Text1>
            <Text2>
              A list of available treatment options including approved therapies and clinical trials can be found below
            </Text2>
          </TitleContainer>

          <Text3>
            Last update: <Text4>{lastTableUpdateTime?.toString()}</Text4>
          </Text3>

          <ActionsListContainer>
            {actions.map((action) => (
              <ActionItemContainer key={action.text} onClick={action.onClick}>
                <ActionImage src={action.imageSrc} />
                <Text5>{action.text}</Text5>
              </ActionItemContainer>
            ))}
          </ActionsListContainer>
        </LeftContainer>
        <GraphicImageContainer>
          <GraphicImage src="/graphic-1.png" />
        </GraphicImageContainer>
      </MainContainer>
    </LayoutRoot>
  );
};

export default HeroSection;

const LayoutRoot = styled.div`
  display: flex;
  padding: 0 70px;
  align-items: center;
  justify-content: center;
  background-image: url('/bg-1.png');

  @media (max-width: 1044px) {
    padding: 0 16px;
  }

  @media print {
    background-image: none;
    padding: 8px;
  }
`;

const MainContainer = styled(HorizontalFlex)`
  max-width: 1320px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 80px;

  @media (max-width: 1044px) {
    max-width: none;
  }
`;

const LeftContainer = styled.div`
  display: flex;
  min-width: 504px;
  flex-direction: column;
  padding-bottom: 175px;
  padding-top: 80px;
  gap: 20px;

  @media (max-width: 1044px) {
    min-width: auto;
    padding-top: 20px;
    padding-bottom: 155px;
    gap: 24px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 650px;
  width: 100%;
`;

const ActionsListContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 60px;

  @media (max-width: 1044px) {
    gap: 24px;
  }

  @media print {
    display: none;
  }

  @media (max-width: 450px) {
    flex-direction: column;
  }
`;

const ActionItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 20px;

  :hover > * {
    color: #3053fc;
  }

  :hover > img {
    transform: scale(1.02);
  }

  @media (max-width: 1044px) {
    gap: 16px;
  }

  @media (max-width: 450px) {
    background: white;
    min-height: 80px;
    border-radius: 15px;
    gap: 20px;
    padding: 0 8px;
  }
`;

const ActionImage = styled.img`
  max-height: 80px;
  height: 100%;
  transition: all 0.25s;

  @media (max-width: 1044px) {
    max-height: 56px;
  }
`;

const GraphicImageContainer = styled.div`
  max-width: 520px;
  width: 100%;
  align-self: start;

  @media (max-width: 764px) {
    display: none;
  }
  @media (max-width: 1044px) {
    display: none;
  }
`;

const GraphicImage = styled.img`
  width: 100%;
`;
